<div class="priority-and-due-date">
  <div class="due-date">
    <button
      mat-icon-button
      [disabled]="!canEdit"
      data-cy="task-unselected-user-control"
      *ngIf="!lookupUser(value)"
      (click)="openDueDatePanel()"
      class="z-0"
      #dueDatePanelOrigin
    >
      <mat-icon svgIcon="account_circle"></mat-icon>
    </button>
    <button
      mat-button
      [disabled]="!canEdit"
      data-cy="task-selected-user-control"
      *ngIf="lookupUser(value) as user"
      (click)="openDueDatePanel()"
      class="z-0"
      #dueDatePanelOrigin
    >
      <span *ngIf="value">{{ user.full_name }}</span>
    </button>
  </div>
  <ng-template #dueDatePanel>
    <div class="tasks-details-user-panel">
      <div class="user-panel-content">
        <div class="user-profile-row unselect" *ngIf="value">
          <button (click)="unselectUser()" data-cy="unselect-user-control">Unselect</button>
        </div>
        <div *ngFor="let user of users" class="user-profile-row">
          <button
            (click)="onSelectUser(user)"
            data-cy="select-user-control"
            [disabled]="!user?.active"
            [ngStyle]="{ color: !user?.active ? '#97a6ba' : 'black' }"
          >
            {{ user.full_name }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
